import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((_theme) => ({
  card: {
    padding: 20,
    border: '1px solid #0e0e0e',
    borderRadius: 10,
    backgroundColor: _theme.palette.background.default,
    color: _theme.palette.text.primary,

    '&>h6': {
      fontSize: 16,
      color: _theme.palette.text.secondary,
      textTransform: 'uppercase',
      marginBottom: 5,
    },
  },
}));
